module.exports = __webpack_public_path__ + "img/navbar_logo@2x.028f7973.png";